import { useEffect } from 'react'
import { Link } from 'react-router'

import { paths } from '@/lib/routes'

import { useToastStore } from './toastBus'
import s from './Toast.module.css'

const TOAST_MS = 2600

/** Renders the current toast in a polite live region; hides itself after ~2.6 s. */
export function Toaster() {
  const toast = useToastStore((st) => st.toast)
  const hide = useToastStore((st) => st.hide)

  useEffect(() => {
    if (!toast) return
    const t = window.setTimeout(hide, TOAST_MS)
    return () => window.clearTimeout(t)
  }, [toast, hide])

  return (
    <output aria-live="polite" className={s.region}>
      {toast && (
        <div key={toast.id} className={s.toast}>
          <span>{toast.message}</span>
          {toast.viewCart && (
            <Link to={paths.cart()} onClick={hide}>
              View cart
            </Link>
          )}
        </div>
      )}
    </output>
  )
}
